import { ApplicationError, ErrorCode } from '../error/application-error';
let _nodeId = '';
export const getNodeId = () => _nodeId;
export const setNodeId = (id) => {
    _nodeId = id;
};
export class HybridLogicalClock {
    constructor(nodeId) {
        this._ts = 0;
        this._counter = 0;
        this._nodeId = nodeId || 'no-node-id';
    }
    static getInstance() {
        if (!_nodeId && process.env.NODE_ENV !== 'test') {
            throw new ApplicationError({
                code: ErrorCode.ERR_INTERNAL_SERVER_ERROR,
                messageExternal: 'Node ID is required to get a HybridLogicalClock instance',
            });
        }
        if (!this._instance) {
            return (this._instance = new this(_nodeId));
        }
        else {
            return this._instance;
        }
    }
    static resetInstance() {
        this._instance = null;
    }
    getWallTime() {
        const ts = Math.floor(Date.now());
        if (ts > this._ts) {
            this._ts = ts;
            this._counter = 0;
        }
        return this._ts;
    }
    observe(ts) {
        if (ts.ts > this._ts) {
            this._ts = ts.ts;
            this._counter = 0;
        }
        return;
    }
    getNextCounter() {
        this._counter += 1;
        return this._counter;
    }
    generateTimestampNow() {
        const ts = this.getWallTime();
        const counter = this.getNextCounter();
        return {
            ts,
            counter,
            nodeId: this._nodeId,
        };
    }
}
export function compareHLCTimestamp(t1, t2) {
    if (t1.ts === t2.ts) {
        if (t1.counter === t2.counter) {
            if (t1.nodeId === t2.nodeId) {
                return 0;
            }
            return t2.nodeId > t1.nodeId ? -1 : 1;
        }
        return t1.counter < t2.counter ? -1 : 1;
    }
    return t1.ts < t2.ts ? -1 : 1;
}
export function compareSortKey(sk1, sk2) {
    if (sk1 === sk2) {
        return 0;
    }
    return sk1 < sk2 ? -1 : 1;
}
export function hlcToSortKey(ts) {
    if (!ts)
        ts = HybridLogicalClock.getInstance().generateTimestampNow();
    return (ts.ts.toString().padStart(15, '0') +
        '-' +
        ts.counter.toString(36).padStart(5, '0') +
        '-' +
        ts.nodeId);
}
export function sortKeyToHLC(serialized) {
    const [ts, count, ...node] = serialized.split('-');
    return {
        ts: parseInt(ts),
        counter: parseInt(count, 36),
        nodeId: node.join('-'),
    };
}
//# sourceMappingURL=hybrid-logical-clock.js.map